import React, { useEffect, useState, useCallback } from "react";
import { Container, Row, Col, Form, Button, Navbar, Nav, NavDropdown, } from "react-bootstrap";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
import { beApiUrl } from "../../api/be_config";
import { NavLink } from 'react-router-dom';
import './Inputquery.css';

export default function Inputquery() {
  const [nodeOneName, setNodeOneName] = useState("");
  const [nodeOneType, setNodeOneType] = useState([]);
  const [nodeTwoName, setNodeTwoName] = useState("");
  const [nodeTwoType, setNodeTwoType] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [nameOptions, setNameOptions] = useState([]);
  const [relation, setRelation] = useState([]);
  const [relationType, setRelationType] = useState([]);
  const navigate = useNavigate();

  // 防抖函数
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
  };

  // Entity Name 前缀搜索函数
  const searchEntityNames = async (prefix) => {
    if (!prefix || prefix.trim() === '') {
      // 如果没有输入，返回初始数据
      return;
    }
    
    try {
      const response = await fetch(beApiUrl + "kgpage/entity_name_search/v1/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          prefix: prefix.trim(),
          limit: 10 
        }),
      });
      
      if (!response.ok) {
        throw new Error("Failed to search entity names.");
      }
      
      const data = await response.json();
      // 将字符串数组转换为对象数组，以匹配现有的数据结构
      const formattedData = data.data.map(name => ({ name: name }));
      setNameOptions(formattedData);
    } catch (error) {
      console.log(error);
    }
  };

  // Entity Type 前缀搜索函数
  const searchEntityTypes = async (prefix) => {
    if (!prefix || prefix.trim() === '') {
      // 如果没有输入，返回初始数据
      return;
    }
    
    try {
      const response = await fetch(beApiUrl + "kgpage/entity_type_search/v1/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          prefix: prefix.trim(),
          limit: 10 
        }),
      });
      
      if (!response.ok) {
        throw new Error("Failed to search entity types.");
      }
      
      const data = await response.json();
      // 将字符串数组转换为对象数组，以匹配现有的数据结构
      const formattedData = data.data.map(type => ({ name: type }));
      setTypeOptions(formattedData);
    } catch (error) {
      console.log(error);
    }
  };

  // 创建防抖版本的搜索函数
  const debouncedSearchEntityNames = useCallback(debounce(searchEntityNames, 300), []);
  const debouncedSearchEntityTypes = useCallback(debounce(searchEntityTypes, 300), []);

  useEffect(() => {
    fetch(beApiUrl + "kgpage/entity_name/v1/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ size_limit: 10 }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to get the entity names.");
        }
        return response.json();
      })
      .then((data) => {
        setNameOptions(data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  useEffect(() => {
    fetch(beApiUrl + "kgpage/entity_type/v1/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ size_limit: 10 }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to get the entity types.");
        }
        return response.json();
      })
      .then((data) => {
        setTypeOptions(data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    fetch(beApiUrl + "kgpage/relation_type/v1/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ size_limit: 10 }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to get the relation types.");
        }
        return response.json();
      })
      .then((data) => {
        setRelationType(data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function kgSubmit(e) {
    e.preventDefault();
    const node_one_name = typeof nodeOneName === 'string' ? nodeOneName : nodeOneName[0]["name"];
    const node_two_name = typeof nodeTwoName === 'string' ? nodeTwoName : nodeTwoName[0]["name"];
    const uri =
      "/showgraph?" +
      "nodeonename=" +
      node_one_name +
      "&nodeonetype=" +
      JSON.stringify(nodeOneType) +
      "&nodetwoname=" +
      node_two_name +
      "&nodetwotype=" +
      JSON.stringify(nodeTwoType) +
      "&relationtype=" +
      JSON.stringify(relation);
    navigate(encodeURI(uri));
  }

  return (
    <>
      <Container className="intro-container">
        <Row style={{ margin: "5px" }}>
          <Col>
            <img src="/fig6.jpg" alt="Related Visual Content" className="img-fluid" />
          </Col>
        </Row>
      </Container>

      <Container className="no-padding">
        <Row style={{ margin: "20px 0px 0px 0px" }}>
          <Col xs={12} md={6}>
          <form id='kginput' onSubmit={kgSubmit}>
            <Form.Group className='mb-3'>
              <Form.Label>Entity I Name</Form.Label>
              <Multiselect
                options={nameOptions}
                displayValue='name'
                onRemove={(e1, e2) => setNodeOneName(e1)}
                onSelect={(e1, e2) => setNodeOneName(e1)}
                onSearch={(value) => debouncedSearchEntityNames(value)}
                placeholder="Search entity names..."
              />
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Label>Entity I Type</Form.Label>
              <Multiselect
                options={typeOptions}
                displayValue='name'
                onRemove={(e1, e2) => setNodeOneType(e1)}
                onSelect={(e1, e2) => setNodeOneType(e1)}
                onSearch={(value) => debouncedSearchEntityTypes(value)}
                placeholder="Search entity types..."
              />
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Label>Entity II Name (optional)</Form.Label>
              <Multiselect
                options={nameOptions}
                displayValue='name'
                onRemove={(e1, e2) => setNodeTwoName(e1)}
                onSelect={(e1, e2) => setNodeTwoName(e1)}
                onSearch={(value) => debouncedSearchEntityNames(value)}
                placeholder="Search entity names..."
              />
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Label>Entity II Type (optional)</Form.Label>
              <Multiselect
                options={typeOptions}
                displayValue='name'
                onRemove={(e1, e2) => setNodeTwoType(e1)}
                onSelect={(e1, e2) => setNodeTwoType(e1)}
                onSearch={(value) => debouncedSearchEntityTypes(value)}
                placeholder="Search entity types..."
              />
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Label>Relation Type (optional)</Form.Label>
              <Multiselect
                options={relationType}
                displayValue='name'
                onRemove={(e1, e2) => setRelation(e1)}
                onSelect={(e1, e2) => setRelation(e1)}
                placeholder="Select relation types..."
              />
            </Form.Group>
            <Button variant='custom' type='submit' className='custom-btn'>
              Search
            </Button>
          </form>
          </Col>
          <Col xs={12} md={6}>
            <img src="/fig10.jpg" alt="Related Visual Content" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </>
  );
}